import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-branch',
  templateUrl: './delete-branch.component.html',
  styleUrls: ['./delete-branch.component.css']
})
export class DeleteBranchComponent implements OnInit {

  modelSubtitle = false
  product:any = []
  deleteId: any = "";

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor( private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getallBranch()
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getallBranch()
  }
 
  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getallBranch(){
    this.generic_service.getBranch().subscribe(
      (response:any)=>{
        this.product = response.response;
      }
    )
  }
 
 

  deleleBranch(){
    this.generic_service.delBranch(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getallBranch();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

}
